import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './popmenuTermsQuery.gql';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type PopmenuTermsQuery_popmenuTerms_PopmenuTerms = {
  __typename: 'PopmenuTerms',
  id: number,
  clientAccessibility: string,
  clientTerms: string,
  dmcaPolicy: string,
  giveawayTerms: string,
  privacy: string
};

export type PopmenuTermsQuery_Query = {
  __typename?: 'Query',
  popmenuTerms: PopmenuTermsQuery_popmenuTerms_PopmenuTerms
};


export type PopmenuTermsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type PopmenuTermsQuery = PopmenuTermsQuery_Query;


export const PopmenuTermsDocument = /*#__PURE__*/ document as unknown as DocumentNode<PopmenuTermsQuery, PopmenuTermsQueryVariables>;


/**
 * __usePopmenuTermsQuery__
 *
 * To run a query within a React component, call `usePopmenuTermsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopmenuTermsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopmenuTermsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePopmenuTermsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PopmenuTermsQuery, PopmenuTermsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PopmenuTermsQuery, PopmenuTermsQueryVariables>(PopmenuTermsDocument, options);
      }
export function usePopmenuTermsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PopmenuTermsQuery, PopmenuTermsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PopmenuTermsQuery, PopmenuTermsQueryVariables>(PopmenuTermsDocument, options);
        }
// @ts-ignore
export function usePopmenuTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PopmenuTermsQuery, PopmenuTermsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PopmenuTermsQuery, PopmenuTermsQueryVariables>;
export function usePopmenuTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PopmenuTermsQuery, PopmenuTermsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PopmenuTermsQuery | undefined, PopmenuTermsQueryVariables>;
export function usePopmenuTermsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PopmenuTermsQuery, PopmenuTermsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PopmenuTermsQuery, PopmenuTermsQueryVariables>(PopmenuTermsDocument, options);
        }
export type PopmenuTermsQueryHookResult = ReturnType<typeof usePopmenuTermsQuery>;
export type PopmenuTermsLazyQueryHookResult = ReturnType<typeof usePopmenuTermsLazyQuery>;
export type PopmenuTermsSuspenseQueryHookResult = ReturnType<typeof usePopmenuTermsSuspenseQuery>;
export type PopmenuTermsQueryResult = ApolloReactCommon.QueryResult<PopmenuTermsQuery, PopmenuTermsQueryVariables>;